import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Information from './Information';
import l from './Label.css';

function BehallInneborden() {
  return (
    <Information>
      <p>
        <span className={l.label}>{'Exempel'}</span>
      </p>
      <p>
        {`
          Du vill märka en produkt med kostrådet ”Byt till Fullkorn” men vill
          omformulera det. En alternativ formulering är t ex ”Följ
          Livsmedelsverkets kostråd – Ät mer fullkorn!”
        `}
      </p>
      <p>
        {`
          Du vill märka en produkt med kostrådet ”Byt till magra
          mejeriprodukter” men vill uttrycka det på annat sätt. Då kan du
          t ex skriva; ”Välj magra mejeriprodukter”
        `}
      </p>
    </Information>
  );
}

export default withStyles(l)(BehallInneborden);



// WEBPACK FOOTER //
// ./src/components/Information/BehallInneborden.js